var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14200",
    "data-name": "Group 14200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2865",
    "data-name": "Rectangle 2865",
    width: 20,
    height: 20,
    fill: "#280f0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13292",
    "data-name": "Group 13292",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12961",
    "data-name": "Path 12961",
    d: "M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0m0,18.509A8.51,8.51,0,1,1,18.508,10,8.518,8.518,0,0,1,10,18.509",
    fill: "#280f0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12962",
    "data-name": "Path 12962",
    d: "M10.444,4.09a2.4,2.4,0,0,0-.27.018h-.092a4.755,4.755,0,0,0-3.6,1.641.77.77,0,0,0-.252.542.686.686,0,0,0,.687.673h0a.8.8,0,0,0,.543-.231,3.552,3.552,0,0,1,2.7-1.234h.02c.071-.007.141-.011.21-.011a2.133,2.133,0,0,1,2.1,1.92l.011.2c0,1.3-1.023,2.118-2.807,2.251a.608.608,0,0,0-.428.192.614.614,0,0,0-.154.463v1.81a.716.716,0,0,0,.718.634h.11a.719.719,0,0,0,.634-.726V10.975l.217-.012a3.445,3.445,0,0,0,3.255-3.458A3.5,3.5,0,0,0,10.444,4.09",
    fill: "#280f0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12963",
    "data-name": "Path 12963",
    d: "M9.857,14.354a.889.889,0,0,0,0,1.778h0a.889.889,0,0,0,0-1.778",
    fill: "#280f0b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueries);
export default __webpack_public_path__ + "static/media/queries.c8f546731e10fd4e1c89fb2ba492b410.svg";
export { ForwardRef as ReactComponent };